/**
 * Bronverwijzingen in de crew-briefing: [mail:…], [meeting:770], [notitie:…], [dossier].
 * De PL ziet ze als klikbare links (bronnen uit callsheet_extra.briefingBronnen);
 * crew-weergave en PDF krijgen schone tekst (Joris 18 sep 2026).
 */
import React from 'react';

const REF_RE = /\s*\[((?:mail|meeting|notitie|dossier|plak|onenote)(?::[^\]\s]+)?)\]/gi;
// Oude stijl "(mail Annemarie 15 sep)" — alleen strippen als er een datum in staat,
// zodat gewone haakjes-tekst blijft staan.
const HAAKJES_RE = /\s*\((?:mail|meeting|notitie|onenote|dossier|bron)\b[^)]{0,60}?\d{1,2}[ -](?:jan|feb|mrt|maart|apr|mei|jun|jul|aug|sep|okt|nov|dec)[a-z]*\.?(?: \d{4})?\)/gi;

export function stripBronRefs(md) {
  return String(md || '').replace(REF_RE, '').replace(HAAKJES_RE, '');
}

function kortLabel(ref, bron) {
  const l = String(bron?.label || '').replace(/^(Mail|Meeting|Notitie|Dossier|Geplakt[^:]*):\s*/i, '');
  const t = (l || ref).replace(/[[\]()]/g, ' ').replace(/\s+/g, ' ').trim();
  return t.length > 48 ? `${t.slice(0, 46)}…` : t;
}

export function bronRefsNaarLinks(md, bronnen = []) {
  const map = new Map((bronnen || []).map((b) => [String(b.ref || '').toLowerCase(), b]));
  return String(md || '').replace(REF_RE, (_m, ref) => {
    const b = map.get(String(ref).toLowerCase());
    const label = kortLabel(ref, b);
    return b?.url ? ` [↗ ${label}](${b.url})` : ` *(${label})*`;
  });
}

// eslint-disable-next-line react/prop-types
export const mdLinkComponents = { a: ({ href, children }) => <a href={href} target="_blank" rel="noreferrer">{children}</a> };
